import { ButtonTriggerEvent } from '../../../common/components';

export class UpgradeModalActions {
    confirm: (event: ButtonTriggerEvent) => void;
    cancel?: () => void;
}



// WEBPACK FOOTER //
// D:/Work/Development/vsts_build/_work/2/s/web/src/components/hub/upgrade.modal/upgrade.modal.provider.ts